// extracted by mini-css-extract-plugin
export default {"listGroup":"ListGroup_listGroup__7ITr4","title":"ListGroup_title__6gr1G","list":"ListGroup_list__OTVTj"};